
<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="pa-3">
          <v-card-title>
            <h4>{{$t($route.meta.breadcrumb[2].text)}}</h4>
          </v-card-title>
          <v-card-subtitle>
            <p>{{$t('company.formMessage')}}</p>
          </v-card-subtitle>
          <v-card-text>
             <div v-if="loading">
              <v-progress-linear
                indeterminate
                :active="loading"
                color="primary"
              ></v-progress-linear>
              <p class="text-center">{{$t('general.loading')}}</p>
            </div>
            <v-form
              v-if="show"
              lazy-validation
              ref="form"
              v-model="valid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.name"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.name')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.bussiness_name">
                    <template v-slot:label>
                      <span>{{$t('address.social_reason')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.phoneRules"
                    v-mask="'(###) ###-####'"
                    type="tel"
                    v-model="company.phone"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.phone')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-select
                    outlined
                    dense
                    return-object
                    :items="formatPDF"
                    v-model="company.custom_report"
                    :rules="rules.required"
                    item-text="description"
                    item-value="value">
                    <template v-slot:label>
                      <span>{{$t('tests.formatPDF')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                    <template v-slot:item="{ item, attrs, on }">
                      <v-list-item two-line v-on="on" v-bind="attrs">
                        <v-list-item-content>
                          <v-list-item-title>{{item.value}}</v-list-item-title>
                          <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    v-model="company.tax_id"
                    :rules="rules.tax">
                    <template v-slot:label>
                      <span>{{$t('address.tax')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-autocomplete
                    outlined
                    dense
                    :items="fiscal"
                    v-model="company.tax_regimen"
                    :rules="rules.required"
                    item-text="name"
                    item-value="name">
                    <template v-slot:label>
                      <span>{{$t('address.tax_regimen')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                  <v-select
                    outlined
                    dense
                    chips
                    multiple
                    deletable-chips
                    :items="defaultChecklist"
                    v-model="company.custom_questionnaire"
                    :rules="rules.requiredMultiple"
                    item-text="description"
                    item-value="value">
                    <template v-slot:label>
                      <span>{{$t('tests.defaultCheck')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                    <template v-slot:item="{ item, attrs, on, active }">
                      <v-list-item two-line v-on="on" v-bind="attrs" #default="{ active }">
                        <v-list-item-action>
                      <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="item.value"></v-list-item-title>
                          <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @mousedown.prevent
                        @click="toggle">
                        <v-list-item-action>
                          <v-icon :color="company.custom_questionnaire && company.custom_questionnaire.length > 0 ? 'primary' : ''">
                            {{ icon }}
                          </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                           {{$t('general.selectAll')}}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0" color="primary">
                        <span>{{ item.value }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text text-caption">
                        (+{{ company.custom_questionnaire && company.custom_questionnaire.length - 1 }})
                      </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <p class="font-weight-bold ma-0 pa-0">{{$t('address.name')}}</p>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.address.street"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.street')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.address.suburb"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.suburb')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.address.state"
                    :label="$t('address.state')"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.state')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    v-model="company.address.zip_code"
                    :rules="rules.textRules"
                    :label="$t('address.zip')"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.zip')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-img
                    style="margin: 0 auto"
                    max-width="320px"
                    v-if="showImg"
                    :src="file.public_url">
                  </v-img>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.streetNumber"
                    v-model="company.address.street_number"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.number')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="company.address.city"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.city')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-autocomplete
                    outlined
                    dense
                    :rules="rules.required"
                    v-model="company.address.country_id"
                    :items="countries"
                    item-text="name"
                    item-value="id"
                    :label="$t('address.country')"
                  >
                    <template v-slot:label>
                      <span>{{$t('address.country')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                  <v-autocomplete
                    outlined
                    dense
                    :rules="rules.required"
                    :items="timezones"
                    item-text="label"
                    item-value="tzCode"
                    :label="$t('address.timeZone')"
                    v-model="company.timezone">
                    <template v-slot:label>
                      <span>{{$t('address.timeZone')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                  <div class="border-img">
                    <vue-dropzone
                      ref="dropzone"
                      id="dropzone"
                      :options="dropzoneOptions"
                      v-on:vdropzone-error="fileError"
                      v-on:vdropzone-success="fileUpload"
                      v-on:vdropzone-removed-file="removed">
                    </vue-dropzone>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    @click="save"
                    class="float-right"
                    color="primary">
                    {{$t('general.save')}}
                  </v-btn>
                   <v-btn
                    @click="redirect"
                    class="float-right mr-3"
                    outlined
                    color="primary">
                    {{$t('general.cancel')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  directives: {mask},
  data () {
    return {
      new: false,
      idEdit: null,
      loading: false,
      countries: [],
      defaultChecklist: [],
      timezones: [],
      formatPDF: [],
      fiscal: [],
      showImg: false,
      show: false,
      valid: false,
      file: {},
      company: {
        custom_report: '',
        custom_questionnaire: [],
        timezone: '',
        logo_id: undefined,
        name: '',
        phone: '',
        tax_regimen: '',
        tax_id: '',
        bussiness_name: '',
        address: {
          street: '',
          street_number: '',
          suburb: '',
          city: '',
          state: '',
          country_id: 150,
          zip_code: ''
        }
      },
      dropzoneOptions: {
        url: process.env.VUE_APP_HOST + 'file',
        dictDefaultMessage: `<p>Logo</p><h1 class="text-center mb-5"><i class="fas fa-cloud-upload-alt"></i></h1>
        </p><span class="text-center mb-0">${this.$t('dropzone.default', { size: '15', unit: 'MB' })}</span>
        <p>${this.$t('general.imgFormats')}</p>`,
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        uploadMultiple: false,
        addRemoveLinks: true,
        maxFilesize: 5,
        paramName: 'path',
        params: {
          'is_public': 1
        },
        acceptedFiles: '.jpg, .png, .jpeg',
        maxFiles: 1,
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.userState.access_token,
          'Cache-Control': null,
          'X-Requested-With': null
        }
      }
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    },
    /**
     * @returns Devuelve la nueva matriz de todos los items del campo cuestionarios predeterminado
     */
    allChecklist () {
      return this.company.custom_questionnaire && (this.company.custom_questionnaire.length === this.defaultChecklist.length)
    },
    /**
     * @returns Devuelve la nueva matriz de los items seleccionados del campo cuestionarios predeterminado
     */
    someChecklist () {
      return (this.company.custom_questionnaire && this.company.custom_questionnaire.length > 0) && !this.allChecklist
    },
    /**
     * @returns Devuelve el icono para el tipo de seleccion en el campo cuestionario predeterminado
     */
    icon () {
        if (this.allChecklist) return 'mdi-close-box'
        if (this.someChecklist) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }
  },
  created () {
    if(this.$route.path === '/company/add') {
      this.show = true
      this.new = true
    } else {
      this.show = false
      this.loading = true
      this.idEdit = this.$route.params.id
      this.$store.dispatch('company/getById', {
        event: {
          context: this,
          id: this.idEdit
        }
      })
    }
    this.$store.dispatch('getCountry', {
      event: {
        context: this
      }
    }),
    this.$store.dispatch('getFiscal', {
      event: { context: this }
    })
    /**
     * @desc Realiza la peticcion para los tipos de checklist
     */
    this.$store.dispatch('company/getChecklist', {
      event: { context: this }
    })
    /**
     * @desc Realiza la peticcion para zona horaria
     */
    this.$store.dispatch('getTimeZone', {
      event: {
        context: this,
        item: {
          perPage: -1,
          page: 1,
          ord: 'asc'
        }
      }
    })
  },
  methods: {
    /**
     * @desc Añade o elimina elementos para el campo Cuestionario predeterminado
     * 
    */
    toggle () {
      this.$nextTick(() => {
        if (this.allChecklist) {
          this.company.custom_questionnaire = []
        } else {
          this.company.custom_questionnaire = this.defaultChecklist.slice()
        }
      })
    },
    fileUpload (file, response) {
      this.company.logo_id = response.data.id
      this.showNotification(this.$t('dropzone.logoSuccess'), 'success')
    },
    fileError (file, message) {
      this.showNotification(message, 'error')
    },
    removed () {
      this.company.logo_id = undefined
    },
    save () {
      this.company.custom_questionnaire.map(e => e.value )
      if (this.$refs.form.validate()) {
        if (this.new) {
          this.company.custom_report = this.company.custom_report.value
          this.$store.dispatch('company/post', {
            event: {
              context: this,
              company: this.company
            }
          })
        } else {
          this.company.custom_report = this.company.custom_report.value ? this.company.custom_report.value : this.company.custom_report
          this.company.logo_id = this.company.logo_id !== null ? this.company.logo_id : undefined
          this.$store.dispatch('company/put', {
            event: {
              context: this,
              company: this.company,
              id: this.idEdit
            }
          })
        }
      }
    },
    redirect () {
      this.$router.push('/company')
    },
    getFile () {
      this.$store.dispatch('getFile', {
        event: {
          context: this,
          id: this.company.logo_id
        }
      })
    },
    showImage () {
      let url = this.file.public_url
      let idx = url.lastIndexOf('https')
      let size = url.lenght
      this.file.public_url = url.substring(idx, size)
      this.showImg = true
    }
  }
}
</script>

<style>
  .dz-error-message {
    display: none !important;
  }
  #dropzone {
    display: flex;
    justify-content: center;
  }
  .border-img {
    border: 1px solid #9E9E9E;
    border-radius: 5px;
    padding: 10px;
  }
</style>